import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
    return (
        <>
            <footer>
                <div className="footer max-w-full mx-auto px-4 sm:px-6 bg-gray-100 border-t border-b py-30">

                    {/* Top area: Blocks */}
                    <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12 border-t border-gray-200 lg:ml-11">

                        {/* 1st block */}
                        <div className="col-span-12 lg:col-span-4">
                            <div className="box-border border-b-4 border-blue-900 p-8 bg-gray-200 text-gray-600 text-center rounded-lg xl:w-80 mx-auto">
                                <h3 className="font-bold text-4xl mb-4">JSS The Print Zone</h3>
                                <div className='text-md font-medium text-gray-600'>
                                    <h5>39, DSIDC Sheds, Scheme-1</h5>
                                    <p>Okhla Phase-2</p>
                                    <p>New Delhi-110020</p>
                                </div>
                            </div>
                        </div>

                        {/* 2nd block */}
                        <div className="col-span-6 md:col-span-6 lg:col-span-1 ml-7 mx-auto">
                            <h6 className="text-[#013289] text-xl font-bold mb-4">LINKS</h6>
                            <ul className="text-md">
                                <li className="mb-2">
                                    <HashLink to="#" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">About</HashLink>
                                </li>
                                <li className="mb-2">
                                    <HashLink to="#" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Services</HashLink>
                                </li>
                                <li className="mb-2">
                                    <HashLink to="#" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Contact</HashLink>
                                </li>
                            </ul>
                        </div>

                        {/* 3rd block */}
                        <div className="col-span-6 md:col-span-6 lg:col-span-4 mx-auto">
                            <h6 className="text-[#013289] text-xl font-bold mb-4">OUR SERVICES</h6>
                            <ul className="text-md">
                                {["Custom Packaging Design", "Offset Printing Solutions", "Luxury Finishing & Foiling", "Die-Cutting & Lamination", "Window Patch Packaging", "Printed Labels & Stickers"].map((service, idx) => (
                                    <li key={idx} className="mb-2">
                                        <Link
                                            to="#services"
                                            className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out"
                                        >
                                            {service}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* 4th block */}
                        <div className="col-span-12 text-center mx-auto lg:col-span-3 font-bold uppercase text-blue-900">
                            <div className="text-xl mb-6">
                                Social Media
                            </div>

                            <div className="text-md font-medium mb-6">
                                Follow us on Instagram.
                            </div>
                            <div className="mx-auto text-center mt-2">
                                <ul className="flex justify-center mb-4 md:mb-0">
                                    <li>
                                        <a href="https://www.instagram.com/jss_the_print_zone/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex justify-center items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out"
                                            aria-label="Instagram">
                                            <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.9.2 2.4.4.6.2 1 .5 1.5 1 .5.5.8.9 1 1.5.2.5.3 1.2.4 2.4.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.2 1.9-.4 2.4-.2.6-.5 1-1 1.5-.5.5-.9.8-1.5 1-.5.2-1.2.3-2.4.4-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.9-.2-2.4-.4-.6-.2-1-.5-1.5-1-.5-.5-.8-.9-1-1.5-.2-.5-.3-1.2-.4-2.4C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.2-1.9.4-2.4.2-.6.5-1 1-1.5.5-.5.9-.8 1.5-1 .5-.2 1.2-.3 2.4-.4C8.4 2.2 8.8 2.2 12 2.2m0-2.2C8.7 0 8.3 0 7 0 5.8 0 4.7.1 3.9.3c-.8.2-1.5.5-2.1 1.1S.5 2.9.3 3.7C.1 4.5 0 5.6 0 6.8c0 1.3 0 1.7.1 4.9s0 3.6.1 4.9c.1 1.2.2 2.3.4 3.1.2.8.5 1.5 1.1 2.1s1.3.9 2.1 1.1c.8.2 1.9.3 3.1.4 1.3.1 1.7.1 4.9.1s3.6 0 4.9-.1c1.2-.1 2.3-.2 3.1-.4.8-.2 1.5-.5 2.1-1.1s.9-1.3 1.1-2.1c.2-.8.3-1.9.4-3.1.1-1.3.1-1.7.1-4.9s0-3.6-.1-4.9c-.1-1.2-.2-2.3-.4-3.1-.2-.8-.5-1.5-1.1-2.1S20.1.5 19.3.3c-.8-.2-1.9-.3-3.1-.4C15.6 0 15.2 0 12 0zm0 5.8a6.2 6.2 0 106.2 6.2A6.2 6.2 0 0012 5.8zm0 10.2a4 4 0 114-4 4 4 0 01-4 4zm6.4-11.8a1.4 1.4 0 11-1.4 1.4 1.4 1.4 0 011.4-1.4z" />
                                            </svg>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>

                    <div className="flex flex-wrap items-center md:justify-between justify-center mx-auto px-4">
                        <div className="w-full md:w-4/12 px-4 mx-auto text-center py-2">
                            <div className="text-sm text-gray-200 font-semibold py-1">
                                Copyright &copy; {new Date().getFullYear()} {"  "}
                                <HashLink to="#" className=" hover:text-gray-900">
                                    JSS The Print Zone
                                </HashLink>. All rights reserved.
                            </div>
                        </div>
                    </div>

                </div>

            </footer>
        </>
    );
};

export default Footer;